/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitAuction } from "../OrbitAuction";

export class OrbitAuction__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(_registry: string, overrides?: Overrides): Promise<OrbitAuction> {
    return super.deploy(_registry, overrides || {}) as Promise<OrbitAuction>;
  }
  getDeployTransaction(
    _registry: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_registry, overrides || {});
  }
  attach(address: string): OrbitAuction {
    return super.attach(address) as OrbitAuction;
  }
  connect(signer: Signer): OrbitAuction__factory {
    return super.connect(signer) as OrbitAuction__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitAuction {
    return new Contract(address, _abi, signerOrProvider) as OrbitAuction;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "AuctionCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "AuctionContract",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minimumBid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reservePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
    ],
    name: "AuctionCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "winner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "winningBid",
        type: "uint256",
      },
    ],
    name: "AuctionResulted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bid",
        type: "uint256",
      },
    ],
    name: "BidPlaced",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bid",
        type: "uint256",
      },
    ],
    name: "BidRefunded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bid",
        type: "uint256",
      },
    ],
    name: "BidWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "UpdateAuctionEndTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reservePrice",
        type: "uint256",
      },
    ],
    name: "UpdateAuctionReservePrice",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "nftAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
    ],
    name: "UpdateAuctionStartTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bidWithdrawalLockTime",
        type: "uint256",
      },
    ],
    name: "UpdateBidWithdrawalLockTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "minBidIncrement",
        type: "uint256",
      },
    ],
    name: "UpdateMinBidIncrement",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "platformFee",
        type: "uint256",
      },
    ],
    name: "UpdatePlatformFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address payable",
        name: "platformFeeRecipient",
        type: "address",
      },
    ],
    name: "UpdatePlatformFeeRecipient",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "addressRegistry",
    outputs: [
      {
        internalType: "contract IOrbitAddressRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenContract",
        type: "address",
      },
    ],
    name: "approveERC20ForRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "auctions",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minBid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reservePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "resulted",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bidWithdrawalLockTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "cancelAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_reservePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_startTimestamp",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "minBidReserve",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_endTimestamp",
        type: "uint256",
      },
    ],
    name: "createAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "getAuction",
    outputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_reservePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_endTime",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_resulted",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "minBid",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "getHighestBidder",
    outputs: [
      {
        internalType: "address payable",
        name: "_bidder",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_bid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lastBidTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "highestBids",
    outputs: [
      {
        internalType: "address payable",
        name: "bidder",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "bid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastBidTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minBidIncrement",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseMarketplace",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_bidAmount",
        type: "uint256",
      },
    ],
    name: "placeBid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "platformFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "reclaimBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenContract",
        type: "address",
      },
    ],
    name: "reclaimERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "reclaimNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "resultAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseMarketplace",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    name: "updateAddressRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_endTimestamp",
        type: "uint256",
      },
    ],
    name: "updateAuctionEndTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_reservePrice",
        type: "uint256",
      },
    ],
    name: "updateAuctionReservePrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256",
      },
    ],
    name: "updateAuctionStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_bidWithdrawalLockTime",
        type: "uint256",
      },
    ],
    name: "updateBidWithdrawalLockTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minBidIncrement",
        type: "uint256",
      },
    ],
    name: "updateMinBidIncrement",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_platformFee",
        type: "uint256",
      },
    ],
    name: "updatePlatformFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "withdrawBid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
